<script lang="ts">
  export let rotate: number = 0;
  export let layer = 0;
  export let scale = 1;
  export let center: { x: number; y: number } = { x: 0, y: 0 };
  export let selected = false;

  $: width = scale * 100;
</script>

<svg
  {width}
  style="transform: rotate({rotate}deg); position: absolute; left: {center.x}px; top: {center.y}px; z-index: {(layer +
    1) *
    100}"
  class:selected
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 64 80"
  x="0px"
  y="0px"
>
  <g>
    <slot />
  </g>
</svg>

<!-- on:mouseup={handleMouseUp} -->
<style lang="postcss">
  .selected {
    background: hsla(200, 50%, 50%, 0.3);
  }
</style>
